import AbstractLayerManager from './AbstractLayerManager';

export default class RefreshableTileLayerManager extends AbstractLayerManager {
	constructor(myKey, instance, layerType, url, options, sublayers) {
		super(myKey, instance);
		
		this.options.hasPanRefresh = false;
		this.options.hasAutoRefresh = true;
		this.layerType = layerType;
		this.url = url;
		this.dataOptions = (options || {});
		this.sublayers = {};
		this.currentSublayer = null;
		if(typeof sublayers === 'object' && sublayers.length) {
			for(let l of sublayers) {
				this.sublayers[l.layerId] = l;
			}
		}
	}

	/* @override */
	attachLayer() {
		if(this.isAttached()) return true;

		// Set any dynamic options
		if(this.dataOptions.time) this.dataOptions.time = (new Date()).getTime();

		// Wire up to parent instance
		if(this.layerType === 'wms') {
			this.inst.layers[this.id] = this.layer = new L.TileLayer.WMS(this.url, this.dataOptions);
		} else if(this.layerType === 'wmts') {
			this.inst.layers[this.id] = this.layer = new L.TileLayer.WMTS(this.url, this.dataOptions);
		} else {
			this.inst.layers[this.id] = this.layer = new L.TileLayer(this.url, this.dataOptions);
		}
		
		if(this.options.hasPanRefresh) this.inst.mapMoveListeners[this.id] = this.id;
		if(this.options.hasAutoRefresh) this.inst.autoUpdateListeners[this.id] = this.id;

		this.layer.on('loading', () => {
			this.inst.setLoadingMonitor(this.id, true);
		});
		this.layer.on('load', () => {
			this.inst.setLoadingMonitor(this.id, false);
		});

		// Sublayer support
		let ks = Object.keys(this.sublayers);
		if(ks.length) {
			// Force set element (sublayer) to either default in list or last used
			this.setElement((this.currentSublayer || ks[0]));
		}

		this.inst.map.addLayer(this.layer);
	}
	
	refreshLayer() {
		this.setOption('time', (new Date()).getTime());
		this.layer.redraw();
	}

	setOptions(o) {
		for(const [k, v] of Object.entries(o)) {
			this.setOption(k, v);
		}
	}

	setOption(k, v) {
		// FIXME could conflict with WMS Params...
		if(typeof this.layer.setParams === 'function') {
			let o = {};
			o[k] = v;
			this.layer.setParams(o);
		}
		this.layer.options[k] = v;
	}

	setUrl(url) {
		this.url = url;
		this.layer.setUrl(url);
	}

	setElement(id) {
		if(this.sublayers && this.sublayers[id]) {
			this.currentSublayer = id;
			if(this.sublayers[id].options) this.setOptions(this.sublayers[id].options);
			this.setUrl(this.sublayers[id].url);
		}
	}
}